import ServiceQuestionModel from "@/models/lab/ServiceQuestionModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

/**
 * ServiceQuestion collection
 */
export default class ServiceQuestionCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return ServiceQuestionModel;
  }

}
